import React, { Component } from "react";
import axios from "axios";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import MuiAlert from "@material-ui/lab/Alert";
import Slide from "@material-ui/core/Slide";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import NumberFormat from "react-number-format";
import Input from "@material-ui/core/Input";
import InputMask from "react-input-mask";
import Select from "@material-ui/core/Select";
import api from "../common/api";
import MediaFile from "../common/MediaFile";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl
} from "@material-ui/core";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        /[A-C,a,c]/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ]}
      //maskPlaceholder={'0'}
      //showMask
      alwaysShowMask={false}
      autoComplete={false}
      showMask={false}
    />
  );
}
function InvoiceNumberMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
      //maskPlaceholder={'0'}
      //showMask
      alwaysShowMask={false}
      autoComplete={false}
      showMask={false}
    />
  );
}

function PointOfSaleMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/\d/, /\d/, /\d/, /\d/]}
      //maskPlaceholder={'0'}
      //showMask
      alwaysShowMask={false}
      autoComplete={false}
      showMask={false}
    />
  );
}

function InvoiceTypeMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/[A-C,a,c]/]}
      //maskPlaceholder={'0'}
      //showMask
      alwaysShowMask={false}
      autoComplete={false}
      showMask={false}
    />
  );
}

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: "100%"
  },
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: "2rem",
    flex: 1,
    color: "white"
  },
  paper: {
    padding: "2rem",
    textAlign: "center"
  },
  checkedIcon: {
    width: 16,
    height: 16
  },
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  },
  typography: {
    fontSize: "0.75rem"
  },
  select: {
    marginTop: "8px",
    marginRight: "8px"
  },
  tableCell: {
    padding: "8px 4px 8px 4px",
    border: "1px solid #dee2e6"
  },
  formControl: {
    marginTop: "6px"
  },
  typography: {
    fontSize: "0.75rem",
    padding: "0px 4px 0px 4px",
    color: "rgba(0, 0, 0, 0.54)"
  }
});

class New extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      vouchers: [],
      voucher: {},
      budget: {},
      payment_deals: [],
      dialog: { open: false, severity: "", message: "" },
      action: "",
      payment_deal: 0,
      payment_deal_hansa_code: "",
      provider_payment_deal: 0,
      saving: false,
      voucher: {
        voucher_total_s_iva_price: 0,
        created_at: new Date().toISOString().slice(0, 10),
        reception_date: new Date().toISOString().slice(0, 10),
        tasks: []
      },
      voucher_types: [],
      iva_conditions: [],
      files: [],
      providers: [],
      budgets: []
    };
  }

  async componentDidMount() {
    //var work_order_id = this.props.work_order.id;
    var work_order_id = window.location.pathname.split("/")[2];
    var voucher = this.state.voucher;
    voucher.voucher_type_id = 1;
    await this.getIvaConditions();
    await this.getBudget(work_order_id);
    await this.getVouchersTaskAvalaible(work_order_id);
    this.setState({
      voucher: voucher,
      work_order_id: work_order_id
    });
  }

  getBudget = async work_order_id => {
    const token = localStorage.getItem("userToken");
    await axios
      .get(api.budgets().get(work_order_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ budget: res.data });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getIvaConditions = async () => {
    const token = localStorage.getItem("userToken");
    await axios
      .get(api.iva_conditions, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ iva_conditions: res.data });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getVouchersTaskAvalaible = id => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.vouchers().tasks_available(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var voucher = this.state.voucher;
        voucher.tasks = res.data;
        voucher.tasks.map((t, idx) => {
          return (t.checked = true);
        });
        this.setState({ voucher: voucher });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getVoucher = async id => {
    const token = localStorage.getItem("userToken");
    axios
      .get(api.vouchers().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(async res => {
        var voucher = this.state.voucher;
        voucher = res.data[0];
        voucher.tasks.map((t, idx) => {
          return (t.checked = true);
        });
        voucher.contact_id = parseInt(res.data[0].contact.id);
        voucher.voucher_type_id = parseInt(res.data[0].voucher_type_id);
        voucher.all_tasks =
          res.data[0].all_tasks === "1" || res.data[0].all_tasks === 1
            ? true
            : false;
        voucher.tasks = res.data[0].tasks;
        voucher.media_url = "";
        if (voucher.media.length > 0)
          voucher.media_url = await this.getMediaUrl(voucher.media[0].id);
        var payment_deal_hansa_code = this.state.payment_deal_hansa_code;
        payment_deal_hansa_code = voucher.custom_payment_deal
          ? voucher.custom_payment_deal
          : payment_deal_hansa_code;
        this.setState({
          voucher: voucher,
          payment_deal_hansa_code: payment_deal_hansa_code
        });
        this.doSubtotals();
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleSubmit = e => {
    this.setState({ saving: true });
    e.preventDefault();
    var formData = new FormData();
    var voucher = this.state.voucher;
    var i = 0;
    if (voucher.all_tasks) {
      formData.set(
        "voucher[" + i + "][work_order_id]",
        this.state.work_order_id
      );
      formData.set(
        "voucher[" + i + "][voucher_type_id]",
        voucher.voucher_type_id
      );
      formData.set(
        "voucher[" + i + "][number]",
        voucher.number ? voucher.number : ""
      );
      formData.set("voucher[" + i + "][budget_id]", this.state.budget.id);
      formData.set(
        "voucher[" + i + "][contact_id]",
        this.state.budget.provider.contact_id
      );
      formData.set(
        "voucher[" + i + "][workforce_s_iva_price]",
        voucher.subtotals.materials
      );
      formData.set(
        "voucher[" + i + "][materials_s_iva_price]",
        voucher.subtotals.workforce
      );
      formData.set(
        "voucher[" + i + "][total_s_iva_price]",
        voucher.subtotals.total
      );
      formData.set(
        "voucher[" + i + "][due_date]",
        voucher.due_date ? voucher.due_date : ""
      );
      formData.set(
        "voucher[" + i + "][reception_date]",
        voucher.reception_date ? voucher.reception_date : ""
      );
      formData.set(
        "voucher[" + i + "][voucher_date]",
        voucher.voucher_date ? voucher.voucher_date : ""
      );
      formData.set("voucher[" + i + "][all_tasks]", 1);
      formData.set("voucher[" + i + "][work_order_task_id]", "");
      formData.set(
        "voucher[" + i + "][voucher_total_s_iva_price]",
        voucher.voucher_total_s_iva_price
          ? voucher.voucher_total_s_iva_price
          : 0
      );
      //		    formData.set("voucher["+i+"][iva_buy_id]", (voucher.iva_buy_id) ? voucher.iva_buy_id : '');
      //		    formData.set("voucher["+i+"][iva_sell_id]", (voucher.iva_sell_id) ? voucher.iva_sell_id : '');
    } else {
      voucher.tasks.map((val, idx) => {
        if (val.checked) {
          formData.set(
            "voucher[" + i + "][voucher_total_s_iva_price]",
            voucher.voucher_total_s_iva_price
              ? voucher.voucher_total_s_iva_price
              : 0
          );
          formData.set(
            "voucher[" + i + "][hansa_voucher_confirmed]",
            voucher.hansa_voucher_confirmed ? 1 : 0
          );
          formData.set(
            "voucher[" + i + "][work_order_id]",
            this.state.work_order_id
          );
          formData.set(
            "voucher[" + i + "][voucher_type_id]",
            voucher.voucher_type_id
          );
          formData.set(
            "voucher[" + i + "][number]",
            voucher.number ? voucher.number : ""
          );
          formData.set("voucher[" + i + "][budget_id]", this.state.budget.id);
          formData.set(
            "voucher[" + i + "][contact_id]",
            this.state.budget.provider.contact_id
          );
          formData.set(
            "voucher[" + i + "][workforce_s_iva_price]",
            val.workforce_s_iva_price
          );
          formData.set(
            "voucher[" + i + "][materials_s_iva_price]",
            val.materials_s_iva_price
          );
          formData.set(
            "voucher[" + i + "][total_s_iva_price]",
            val.total_s_iva_price
          );
          formData.set(
            "voucher[" + i + "][voucher_total_s_iva_price]",
            voucher.voucher_total_s_iva_price
              ? voucher.voucher_total_s_iva_price
              : 0
          );
          formData.set(
            "voucher[" + i + "][due_date]",
            voucher.due_date ? voucher.due_date : ""
          );
          formData.set(
            "voucher[" + i + "][reception_date]",
            voucher.reception_date ? voucher.reception_date : ""
          );
          formData.set(
            "voucher[" + i + "][voucher_date]",
            voucher.voucher_date ? voucher.voucher_date : ""
          );
          formData.set("voucher[" + i + "][all_tasks]", 0);
          formData.set(
            "voucher[" + i + "][work_order_task_id]",
            val.id ? val.id : val.work_order_task_id
          );
          formData.set(
            "voucher[" + i + "][iva_buy_id]",
            val.iva_buy_id ? val.iva_buy_id : ""
          );
          if (this.props.can_change_payment_deadline) {
            if (
              parseInt(this.state.provider_payment_deal) !==
              parseInt(this.state.payment_deal)
            ) {
              formData.set(
                "voucher[" + i + "][custom_due_date]",
                voucher.due_date ? voucher.due_date : ""
              );
              formData.set(
                "voucher[" + i + "][custom_payment_deal]",
                this.state.payment_deal_hansa_code
                  ? this.state.payment_deal_hansa_code
                  : ""
              );
            }
          }
          if (
            this.state.voucher_realted &&
            this.state.voucher_realted.hansa_code
          ) {
            //						formData.set("voucher["+i+"][hansa_code]", this.state.voucher_realted.hansa_code);
          }
          //formData.set("voucher["+i+"][iva_sell_id]", (val.iva_sell_id) ? val.iva_sell_id : '');
          i++;
        }
      });
    }
    i = 0;
    if (this.state.files) {
      this.state.files.map((val, idx) => {
        if (val.file !== "" && val.file !== undefined) {
          formData.append("media[" + i + "][file]", val.file[0]);
          i++;
        }
      });
    }
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(api.vouchers().post(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var dialog = this.state.dialog;
        dialog.open = true;
        dialog.severity = "success";
        dialog.message = "Comprobante cargado con éxito";
        this.setState({ dialog: dialog });
        this.setState({ saving: false });
      })
      .catch(function(error) {
        var error_message = "";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = "Ha ocurrido un error. Contacte a su administrador";
          }
        } else {
          error_message = "Ha ocurrido un error. Contacte a su administrador";
        }

        var dialog = {
          open: true,
          message: error_message,
          severity: "error"
        };
        self.setState({ dialog: dialog });
        self.setState({ saving: false });
      });
  };

  handleUploadFile = (file, meta_data) => {
    var files_state = this.state.files;
    var file = { file: file, meta_data: meta_data };
    files_state.push(file);
    this.setState({ files: files_state });
  };

  handleDeleteFile = () => {
    this.setState({ files: [] });
  };
  handleChange = e => {
    var voucher = this.state.voucher;
    var payment_days_value = this.state.payment_deal
      ? this.state.payment_deal
      : 0;

    if (e.target.name === "voucher_date" || e.target.name === "payment_deal") {
      if (e.target.name === "payment_deal") {
        this.setState({ payment_deal_hansa_code: e.target.value });
        var hansa_payment_deal = this.state.payment_deals.filter(
          p => p.hansa_code === e.target.value
        )[0];

        this.setState({ payment_deal: hansa_payment_deal.days_value });
        payment_days_value = hansa_payment_deal.days_value;
      }
      if (e.target.name === "voucher_date") {
        voucher.voucher_date = e.target.value;
      }
      //var payment_days_value = (this.state.providers[0]) ? (this.state.providers[0].payment_deal) ? this.state.providers[0].payment_deal : 0 : 0
      var due_date = "";
      if (payment_days_value >= 0 && payment_days_value !== "") {
        due_date = new Date(voucher.voucher_date);

        if (due_date) {
          due_date.setDate(due_date.getDate() + payment_days_value);
          if (!isNaN(due_date.getTime())) {
            voucher.due_date = due_date.toISOString().slice(0, 10);
          }
        }
      }
    } else if (e.target.name === "voucher_total_s_iva_price") {
      voucher.voucher_total_s_iva_price = e.target.value.replace("$", "");
    } else if (
      e.target.name === "invoice_type" ||
      e.target.name === "invoice_pos" ||
      e.target.name === "invoice_number"
    ) {
      voucher[e.target.name] = e.target.value;
      voucher["number"] =
        voucher.invoice_type +
        "-" +
        voucher.invoice_pos +
        "-" +
        voucher.invoice_number;
    } else {
      voucher[e.target.name] = e.target.value;
    }
    this.setState({ voucher: voucher });
  };

  autcompleteNumber = e => {
    var voucher = this.state.voucher;
    var voucher_number = voucher.number.split("-");
    if (voucher_number.length === 3) {
      voucher_number[0] = voucher_number[0].toUpperCase();
      voucher_number[1] = voucher_number[1].replaceAll("_", "");
      voucher_number[2] = voucher_number[2].replaceAll("_", "");
      if (voucher_number[1].length > 0) {
        voucher_number[1] = voucher_number[1].padStart(4, "0");
        voucher.invoice_pos = voucher_number[1];
      }
      if (voucher_number[2].length > 0) {
        voucher_number[2] = voucher_number[2].padStart(8, "0");
        voucher.invoice_number = voucher_number[2];
      }
      voucher.number = voucher_number.join("-");
      this.setState({ voucher: voucher });
    }
  };

  handleTaskChange = e => {
    var voucher = this.state.voucher;
    var element = e.target.name.split(".");
    var key = element[0];
    var id = element[1];
    if (key === "checked") {
      voucher.tasks[id]["checked"] = e.target.checked;
    } else {
      voucher.tasks[id][key] = e.target.value.replace("$", "");
    }
    this.setState({ voucher: voucher });
    this.doSubtotals();
  };

  doSubtotals = () => {
    var subtotals = { materials: 0, workforce: 0, total: 0 };
    var voucher = this.state.voucher;
    //		var voucher_related = this.state.voucher_related
    for (var i = 0; i < voucher.tasks.length; i++) {
      if (voucher.tasks[i].checked === true) {
        voucher.tasks[i].materials_s_iva_price =
          voucher.tasks[i].materials_s_iva_price !== null
            ? voucher.tasks[i].materials_s_iva_price
            : 0;
        voucher.tasks[i].workforce_s_iva_price =
          voucher.tasks[i].workforce_s_iva_price !== null
            ? voucher.tasks[i].workforce_s_iva_price
            : 0;
        voucher.tasks[i].total_s_iva_price =
          voucher.tasks[i].total_s_iva_price !== null
            ? voucher.tasks[i].total_s_iva_price
            : 0;
        if (
          voucher.tasks[i].workforce_s_iva_price > 0 ||
          voucher.tasks[i].materials_s_iva_price > 0
        ) {
          subtotals.materials += voucher.tasks[i].materials_s_iva_price
            ? +parseFloat(voucher.tasks[i].materials_s_iva_price)
            : 0;
          subtotals.workforce += voucher.tasks[i].workforce_s_iva_price
            ? +parseFloat(voucher.tasks[i].workforce_s_iva_price)
            : 0;
          voucher.tasks[i].total_s_iva_price =
            +parseFloat(voucher.tasks[i].workforce_s_iva_price) +
            +parseFloat(voucher.tasks[i].materials_s_iva_price);
        } else {
          voucher.tasks[i].total_s_iva_price = +parseFloat(
            voucher.tasks[i].total_s_iva_price
          );
        }
        voucher.tasks[i].total_s_iva_price = Number(
          voucher.tasks[i].total_s_iva_price.toFixed(2)
        );
        subtotals.total += +parseFloat(voucher.tasks[i].total_s_iva_price);
        //				voucher_related.total_s_iva_price = +parseFloat(voucher.tasks[i].total_s_iva_price);
        //				voucher_related.total_s_iva_price = Number((voucher_related.total_s_iva_price).toFixed(2));
      }
    }
    voucher.subtotals = subtotals;
    this.setState({ voucher: voucher });
    //		this.setState({voucher_related:voucher_related})
  };

  handleAllTasksChange = e => {
    var voucher = this.state.voucher;
    voucher.all_tasks = e.target.checked;
    voucher.tasks.map((val, idx) => {
      voucher.tasks[idx].checked = e.target.checked;
    });
    this.setState({ voucher: voucher });
    this.doSubtotals();
  };
  getMediaUrl = async id => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.media_path + "/" + id, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  };
  render() {
    const classes = this.props.classes;
    var payment_deal = this.state.payment_deal ? this.state.payment_deal : 0;
    const iva_conditions_buy = this.state.iva_conditions.filter(
      cond => cond.is_buy === 1 || cond.is_buy === "1"
    );
    const handleRedirect = id => () => {
      window.location.href = `/pending`;
    };

    return (
      <React.Fragment>
        <Dialog
          open={this.state.dialog.open}
          fullWidth
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">{"Factura"}</DialogTitle>
          <DialogContent>
            <DialogContentText>{this.state.dialog.message}</DialogContentText>
          </DialogContent>
          <DialogActions disableSpacing="false">
            <Button
              onClick={
                this.state.dialog.severity === "success"
                  ? handleRedirect()
                  : () => this.setState({ dialog: { open: false } })
              }
              variant="contained"
              color="primary"
            >
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>

        <div className="row mt-2 ml-2">
          <div className="col-md-8">
            <TextField
              id="invoice_type"
              name="invoice_type"
              select
              margin="normal"
              label="Tipo de factura"
              className="m-0 p-0 mt-2 mr-2"
              InputLabelProps={{
                shrink: true
              }}
              onChange={this.handleChange}
              value={this.state.voucher.invoice_type}
              InputProps={{
                style: { fontSize: "0.75rem", width: 110 }
              }}
            >
              <MenuItem
                key={"factura-a"}
                value={"A"}
                className={classes.typography}
              >
                Factura A
              </MenuItem>
              <MenuItem
                key={"factura-c"}
                value={"C"}
                className={classes.typography}
              >
                Factura C
              </MenuItem>
            </TextField>
            <FormControl
              className={classes.formControl}
              inputProps={{ shrink: true }}
            >
              <Typography className={classes.typography}>Pto Venta</Typography>
              <Input
                id="invoice_pos"
                name="invoice_pos"
                //label="Punto de venta"
                value={this.state.voucher.invoice_pos}
                onChange={this.handleChange}
                InputLabelProps={{
                  shrink: true
                }}
                style={{ width: 30, fontSize: "0.75rem" }}
                inputComponent={PointOfSaleMaskCustom}
                onBlur={this.autcompleteNumber}
              />
            </FormControl>

            <FormControl
              className={classes.formControl}
              inputProps={{ shrink: true }}
            >
              <Typography className={classes.typography}>Nro comp</Typography>
              <Input
                id="invoice_number"
                name="invoice_number"
                value={this.state.voucher.invoice_number}
                onChange={this.handleChange}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                style={{ width: 60, fontSize: "0.75rem" }}
                inputComponent={InvoiceNumberMaskCustom}
                onBlur={this.autcompleteNumber}
              />
            </FormControl>

            <div className="row">
              <div className="col-md-12">
                <TextField
                  id="voucher_date"
                  value={this.state.voucher.voucher_date}
                  onChange={this.handleChange}
                  type="date"
                  required
                  name="voucher_date"
                  margin="normal"
                  className="m-0 p-0 mr-2 mt-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    max: "9999-12-31",
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 100 }}>
                          Fecha de factura
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  inputProps={{
                    max: "9999-12-31",
                    style: { minWidth: 100, fontSize: "0.75rem" }
                  }}
                />
                <TextField
                  id="created_at"
                  value={this.state.voucher.created_at}
                  onChange={this.handleChange}
                  type="date"
                  disabled
                  required
                  name="created_at"
                  margin="normal"
                  className="m-0 p-0 mr-2 mt-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption" style={{ width: 100 }}>
                          Fecha de carga
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 mt-4 ml-0">
                <Table
                  size="small"
                  aria-label="a dense table"
                  style={{ width: "auto", minWidth: "650px" }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: "550" }}
                      ></TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: "550" }}
                      >
                        Tarea
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: "550" }}
                      >
                        Mano de obra s/iva
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: "550" }}
                      >
                        Repuestos s/iva
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: "550" }}
                      >
                        Total s/iva
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: "550" }}
                      >
                        IVA Compras
                      </TableCell>
                      {/*<TableCell className={classes.tableCell} style={{fontWeight: '550'}} >IVA Ventas</TableCell>*/}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.voucher.tasks.map((val, idx) => {
                      return (
                        <React.Fragment>
                          <TableRow>
                            <TableCell
                              className={classes.tableCell}
                              style={{ fontSize: "0.75rem" }}
                            >
                              {this.state.voucher.all_tasks ? (
                                ""
                              ) : (
                                <Checkbox
                                  name={"checked." + idx}
                                  id={"checked." + idx}
                                  checked={val.checked}
                                  onChange={this.handleTaskChange}
                                />
                              )}
                            </TableCell>
                            <TableCell
                              className={classes.tableCell}
                              style={{ fontSize: "0.75rem" }}
                            >
                              {val.task.name}
                            </TableCell>

                            <TableCell
                              className={classes.tableCell}
                              style={{ fontSize: "0.75rem" }}
                            >
                              <NumberFormat
                                id={"workforce_s_iva_price." + idx}
                                name={"workforce_s_iva_price." + idx}
                                value={val.workforce_s_iva_price}
                                placeholder="Ingrese la mano de obra"
                                onChange={this.handleTaskChange}
                                className="m-0 p-0"
                                InputProps={{
                                  style: {
                                    minWidth: 70,
                                    fontSize: "0.75rem"
                                  }
                                }}
                                disabled={
                                  !val.task.workforce_account_cost
                                    ? true
                                    : false
                                }
                                decimalSeparator="."
                                prefix={"$"}
                                customInput={TextField}
                                InputLabelProps={{
                                  shrink: true
                                }}
                                isAllowed={values => {
                                  let { floatValue } = values;
                                  floatValue =
                                    floatValue !== undefined ? floatValue : 0;
                                  return (
                                    floatValue >= 0 && floatValue < 99999999
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell
                              className={classes.tableCell}
                              style={{ fontSize: "0.75rem" }}
                            >
                              <NumberFormat
                                id={"materials_s_iva_price." + idx}
                                name={"materials_s_iva_price." + idx}
                                value={val.materials_s_iva_price}
                                placeholder="Ingrese los materiales"
                                onChange={this.handleTaskChange}
                                className="m-0 p-0"
                                InputProps={{
                                  style: {
                                    minWidth: 70,
                                    fontSize: "0.75rem"
                                  }
                                }}
                                decimalSeparator="."
                                prefix={"$"}
                                customInput={TextField}
                                InputLabelProps={{
                                  shrink: true
                                }}
                                isAllowed={values => {
                                  let { floatValue } = values;
                                  floatValue =
                                    floatValue !== undefined ? floatValue : 0;
                                  return (
                                    floatValue >= 0 && floatValue < 99999999
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell
                              className={classes.tableCell}
                              style={{ fontSize: "0.75rem" }}
                            >
                              <NumberFormat
                                id={"total_s_iva_price." + idx}
                                name={"total_s_iva_price." + idx}
                                value={val.total_s_iva_price}
                                placeholder="Ingrese el total"
                                //disabled={true}
                                onChange={this.handleTaskChange}
                                className="m-0 p-0"
                                InputProps={{
                                  style: {
                                    minWidth: 70,
                                    fontSize: "0.75rem"
                                  }
                                }}
                                disabled={
                                  !val.task.total_account_cost ? true : false
                                }
                                decimalSeparator="."
                                prefix={"$"}
                                customInput={TextField}
                                InputLabelProps={{
                                  shrink: true
                                }}
                                isAllowed={values => {
                                  let { floatValue } = values;
                                  floatValue =
                                    floatValue !== undefined ? floatValue : 0;
                                  return (
                                    floatValue >= 0 && floatValue < 99999999
                                  );
                                }}
                              />
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                              <Select
                                native
                                name={"iva_buy_id." + idx}
                                inputProps={{
                                  name: "iva_buy_id." + idx,
                                  className: "iva_buy_id." + idx
                                }}
                                value={val.iva_buy_id}
                                style={{ fontSize: "0.75rem", width: 70 }}
                                onChange={this.handleTaskChange}
                                required
                                input={
                                  <Input
                                    id="grouped-native-select"
                                    name="contract_id"
                                  />
                                }
                              >
                                <option value="" />
                                {iva_conditions_buy.map(condition => (
                                  <option
                                    id={condition.name}
                                    value={condition.id}
                                  >
                                    {condition.name}
                                  </option>
                                ))}
                              </Select>
                            </TableCell>
                            {/*<TableCell className={classes.tableCell}>
															<Select native name={"iva_sell_id."+idx}
																inputProps={{
																name:"iva_sell_id."+idx,
																className:"iva_sell_id."+idx
																}}
																value={val.iva_sell_id}
																style={{fontSize: '0.75rem', width: 70}}
																onChange={this.handleTaskChange}
																required
																input={<Input id="grouped-native-select" name='contract_id'/>}>
																<option value="" />
																{iva_conditions.sell.map((condition) => <option id={condition.name} value={condition.id}>{condition.name}
															</option>)}
															</Select>
														</TableCell>
														*/}
                          </TableRow>
                        </React.Fragment>
                      );
                    })}
                  </TableBody>
                </Table>
                <div className="row mt-2 ml-0">
                  <Button
                    disabled={this.state.saving ? true : false}
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ fontSize: "0.75rem" }}
                    onClick={this.handleSubmit}
                  >
                    Guardar
                  </Button>

                  <MediaFile
                    files={this.state.files}
                    onChange={this.handleUploadFile}
                    title="Agregar comprobante"
                    width={"15rem"}
                    height={"2rem"}
                    meta_data="comprobante"
                    acceptedFiles={[".pdf"]}
                  />
                  {this.state.files.length > 0 && (
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      style={{ fontSize: "0.75rem", marginRight: "8px" }}
                      onClick={this.handleDeleteFile}
                    >
                      Eliminar adjunto
                    </Button>
                  )}

                  {this.state.voucher.id > 0 ? (
                    this.state.voucher.media.length > 0 ? (
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{ fontSize: "0.75rem", marginRight: "8px" }}
                        onClick={e => {
                          window.open(
                            api.media_download +
                              "/" +
                              this.state.voucher.media[0].id,
                            "_blank"
                          );
                        }}
                      >
                        Descargar
                      </Button>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                  <Button
                    variant="contained"
                    color="secondary"
                    className="ml-2"
                    size="small"
                    style={{ fontSize: "0.75rem" }}
                    href="/pending"
                  >
                    Volver
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            {this.state.files[0] && (
              <embed
                src={
                  URL.createObjectURL(this.state.files[0].file[0]) +
                  "#toolbar=0&navpanes=0&scrollbar=0"
                }
                width="100%"
                height="600"
                type="application/pdf"
              />
            )}
            {this.state.voucher.media_url && (
              <embed
                src={
                  this.state.voucher.media_url +
                  "#toolbar=0&navpanes=0&scrollbar=0"
                }
                width="100%"
                height="600"
                type="application/pdf"
              />
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(New);
